module.exports = __webpack_public_path__ + "static/selector-structure-d79cfe18021df6cf94822e4abce8d231.png";